import {Grid, GridCellProps, GridColumn, GridDetailRowProps} from "@progress/kendo-react-grid"
import {Tooltip} from "@progress/kendo-react-tooltip"

const DefectGrid = (props: GridDetailRowProps) => {
    const TooltipCell = (props: GridCellProps) => (
        <td title={props.dataItem[`${props.field}`]}>{props.dataItem[`${props.field}`]}</td>
    )

    return (
        <Tooltip openDelay={100} position="bottom" anchorElement="pointer">
            <Grid data={props.dataItem.defects}>
                <GridColumn field="failureItemNo" title="Item number" width={150} />
                <GridColumn field="failureReason" title="Reason" cell={TooltipCell} />
                <GridColumn field="severityCode" title="Severity Code" width={200} />
                <GridColumn field="severityDescription" title="Severity description" cell={TooltipCell} />
            </Grid>
        </Tooltip>
    )
}

export default DefectGrid
